// extracted by css-extract-rspack-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview__vbOt_","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer__cmBKl"};